import { useCallback } from 'react';
import { useLanguage } from '../contexts/language';
import { IotsApiError } from '../utils/fetchData';
import { ErrorType } from '../types/core';

const useApiErrorMessageGetter = () => {
  const { t } = useLanguage();

  return useCallback(
    (error: unknown, prefixText = '') => {
      const errorTranslationCode =
        `error-response.${error instanceof IotsApiError ? error.type : ErrorType.GenericError}`.toLocaleLowerCase();

      let errorMessage = t(errorTranslationCode);

      errorMessage =
        errorMessage !== errorTranslationCode
          ? errorMessage
          : t(`error-response.${ErrorType.GenericError}`);

      return [prefixText?.replace(/[.,:]$/, ''), errorMessage]
        .filter(Boolean)
        .join(': ');
    },
    [t],
  );
};

export default useApiErrorMessageGetter;
